module.exports = __webpack_public_path__ + "static/media/  (117).2c962197.jpg";